module.exports = __webpack_public_path__ + "c8b0f61f900e76780b194fdfcf8ddd46.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/ModulesLanding/module1.png
// module id = 1378
// module chunks = 0